import styled from 'styled-components';

type ConsentProps = {
  brandColor?: string;
  borderColor?: string;
};

export const ConsentCheckbox = styled.div<ConsentProps>`
  display: flex;
  align-items: center;
  .checkbox span {
    top: -1px;
  }
  .checkbox {
    background: ${({ brandColor }) => brandColor};
    pointer-events: none;
    border: ${({ borderColor }) => `1px solid ${borderColor}`};
  }
`;
